<script>
export default {
  name: 'klimachecklist',
  components: {},
  data () {
    return {
      insideLoading: false,
      salesPerson: '',
      haaId: '',
      project: null,
      tilbudData: [],
      appointmentId: '',
      contactId: '',
      klimaMainData: [],
      klimaDraftData: [],
      klimaVisible: false,
      klimaPlanVisible: true,
      mainKlimaVisible: false,
      draftKlimaVisible: false,
      klimaQualityAssuranceVisible: false,
      reportSent: false
    }
  },
  created () {
    if (screen.width <= 640) {
      this.showMobile = true
    } else {
      this.showMobile = false
    }
    this.salesPerson = localStorage.getItem('id_token_portal')
    this.haaId = localStorage.getItem('haaid')
    var urlStr = window.location.href
    var url = new URL(urlStr.replace('/#', ''))
    var searchParams = url.searchParams
    var appointmentId = searchParams.get('appointmentId')
    this.appointmentId = appointmentId
    var contactId = searchParams.get('contactId')
    this.contactId = contactId
    this.displayPlan()
    this.getProject()
  },
  methods: {
    gotominekunder () {
      this.$router.push('/alle-moeder')
    },
    refreshpage () {
      this.$router.push('/klima/checklist?appointmentId=' + this.appointmentId + '&contactId=' + this.contactId + '&customerid=' + this.appointmentId)
    },
    gotoSurvey () {
      this.$router.push('/klima/survey?appointmentId=' + this.appointmentId + '&contactId=' + this.contactId)
    },
    gotoPlan () {
      this.$router.push('/klima/klima')
    },
    gotoEditKlima (klimaId, draft) {
      this.$router.push('/klima/klima?appointmentId=' + this.appointmentId + '&klimaId=' + klimaId + '&contactId=' + this.contactId + '&draft=' + draft)
    },
    gotoDocumentation (klimaId) {
      this.$router.push('/klima/documentation?klimaId=' + klimaId + '&contactId=' + this.contactId + '&appointmentId=' + this.appointmentId)
    },
    changeItem: function changeItem (rowId, event) {
      this.selected = 'rowId: ' + rowId + ', target.value: ' + event.target.value
    },
    getKlimaStatus (klimaId) {
      var data = {
        operation: 'klimaApi',
        salesPerson: this.salesPerson,
        levid: this.haaId,
        ContactId: this.contactId,
        CompanyId: this.haaId,
        parameters: JSON.stringify({
          operation: 'klimaStatus',
          CompanyId: this.haaId,
          ContactId: this.contactId,
          klimaId: klimaId,
          to: 'customer'
        })
      }
      this.$http.post('', data, { emulateJSON: true }).then(
        response => {
          var res = response.body
          if (res.success) {
            if (res.data.EntrySurvey === true) {
              this.draftKlimaVisible = false
            }
            if (!this.reportSent) {
              if (res.data.EntrySurvey === true && res.data.CustomerSurvey === true && res.data.PartnerSurvey === true) {
                this.klimaQualityAssuranceVisible = true
              } else {
                this.klimaQualityAssuranceVisible = false
              }
            }
            this.insideLoading = false
          } else {
            this.$toastr('error', 'Error in getKlimaStatus()')
          }
        },
        response => {
          this.$toastr('error', 'Error in getKlimaStatus()')
        }
      )
    },
    displayPlan () {
      var data = {
        operation: 'klimaApi',
        salesPerson: this.salesPerson,
        levid: this.haaId,
        ContactId: this.contactId,
        CompanyId: this.haaId,
        parameters: JSON.stringify({
          operation: 'getKlima',
          ContactId: this.contactId,
          CompanyId: this.haaId
        })
      }
      this.$http.post('', data, { emulateJSON: true }).then(
        response => {
          var res = response.body
          if (res.success) {
            var mainFound = false
            var draftFound = false
            for (var i = 0; i < res.data.main.length; i++) {
              if (res.data.main[i].contact === this.contactId) {
                if (!mainFound) {
                  this.klimaMainData = res.data.main[i]
                  this.klimaDraftData = res.data.draft[i]
                  this.getKlimaStatus(res.data.main[i].klimaId)
                  if (res.data.main[i].report_sent) {
                    this.reportSent = true
                  } else {
                    this.reportSent = false
                  }
                  mainFound = true
                }
              }
              this.klimaVisible = true
            }
            for (var j = 0; j < res.data.draft.length; j++) {
              if (res.data.draft[j].contact === this.contactId) {
                if (!draftFound) {
                  this.klimaDraftData = res.data.draft[j]
                  draftFound = true
                }
              }
            }
            if (!this.reportSent) {
              this.mainKlimaVisible = true
              if (res.data.draft.length > 0) {
                this.draftKlimaVisible = true
              } else {
                this.draftKlimaVisible = false
              }
            } else {
              this.mainKlimaVisible = false
              this.draftKlimaVisible = false
              this.klimaReportVisible = false
              this.klimaQualityAssuranceVisible = false
            }
          } else {
            this.klimaVisible = true
            this.mainKlimaVisible = false
            this.draftKlimaVisible = false
            this.insideLoading = false
            // this.$toastr('error', 'Error in displayPlan1()')
          }
        },
        response => {
          this.$toastr('error', 'Error in displayPlan()')
        }
      )
      this.insideLoading = true
    },
    getProject () {
      var data = {
        operation: 'userTilbud',
        salesPerson: this.salesPerson,
        tilbud_id: this.appointmentId
      }
      this.$http.post('', data, { emulateJSON: true }).then(
        response => {
          var res = response.body
          this.tilbudData = res.tilbud
          if (this.tilbudData.length <= 0) {
            document.querySelector('p.el-select-dropdown__empty').innerText = 'Ingen data.'
          }
        },
        response => {
          this.$toastr('error', 'Error in getProject()')
        }
      )
    },
    projectChanged () {
      var data = {
        operation: 'klimaApi',
        salesPerson: this.salesPerson,
        levid: this.haaId,
        ContactId: this.contactId,
        CompanyId: this.haaId,
        parameters: JSON.stringify({
          operation: 'getKlima',
          ContactId: this.contactId,
          CompanyId: this.haaId
        })
      }
      this.$http.post('', data, { emulateJSON: true }).then(
        response => {
          var res = response.body
          if (res.success) {
            var mainFound = false
            var draftFound = false
            for (var i = 0; i < res.data.main.length; i++) {
              if (res.data.main[i].offer === this.project) {
                if (!mainFound) {
                  this.klimaMainData = res.data.main[i]
                  this.klimaDraftData = res.data.draft[i]
                  this.getKlimaStatus(res.data.main[i].klimaId)
                  if (res.data.main[i].report_sent) {
                    this.reportSent = true
                  } else {
                    this.reportSent = false
                  }
                  mainFound = true
                }
              }
              this.klimaVisible = true
            }
            for (var j = 0; j < res.data.draft.length; j++) {
              if (res.data.draft[j].offer === this.project) {
                if (!draftFound) {
                  this.klimaDraftData = res.data.draft[j]
                  draftFound = true
                }
              }
            }
            if (!this.reportSent) {
              this.mainKlimaVisible = true
              if (res.data.draft.length > 0) {
                this.draftKlimaVisible = true
              } else {
                this.draftKlimaVisible = false
              }
            } else {
              this.mainKlimaVisible = false
              this.draftKlimaVisible = false
              this.klimaReportVisible = false
              this.klimaQualityAssuranceVisible = false
            }
          } else {
            this.klimaVisible = true
            this.mainKlimaVisible = false
            this.draftKlimaVisible = false
            this.insideLoading = false
            // this.$toastr('error', 'Error in projectChanged()')
          }
        },
        response => {
          this.$toastr('error', 'Error in projectChanged()')
        }
      )
      this.insideLoading = true
    },
    addPlan () {
      var data = {
        operation: 'klimaApi',
        salesPerson: this.salesPerson,
        levid: this.haaId,
        ContactId: this.contactId,
        CompanyId: this.haaId,
        parameters: JSON.stringify({
          draft: 0,
          klimaId: 0,
          operation: 'addKlima',
          ContactId: this.contactId,
          CompanyId: this.haaId,
          info: '',
          offerId: this.project,
          userplan: [],
          usersurvey: []
        })
      }
      this.$http.post('', data, { emulateJSON: true }).then(
        response => {
          var res = response.body
          if (res.success) {
            this.gotoEditKlima(res.data.klimaId, 0)
            this.insideLoading = false
          } else {
            this.$toastr('error', 'Error in addPlan()')
          }
        },
        response => {
          this.$toastr('error', 'Error in addPlan()')
        }
      )
      this.insideLoading = true
    }
  },
  computed: {}
}
</script>
<template>
<div id="checklist" class="animated fadeIn">
    <!-- mobile view -->
    <!-- <div class="clearfix fullHeight p2" v-if="showMobile">
      <div class="col-12 px0 flex justify-between items-center"> -->
        <!-- back button -->
        <!-- <div @click="$router.go(-1)" class="clearfix primarycolor flex justify-start items-center">
          <span class="mr1"><i class="el-icon-back"></i></span>
          <span class="h5 gibson line-height-1 m0 p0">Tilbage</span>
        </div> -->
        <!-- opdater -->
      <!--   <div class="clearfix primarycolor flex justify-start items-center">
          <span class="mr1"><i class="el-icon-refresh-right"></i></span>
          <span class="h5 gibson line-height-1 m0 p0">Opdater</span>
        </div>
      </div>
    </div> -->
    <div class="col-10 lg-col-4 md-col-9 py3 highlights mx-auto mt3">
      <div class=" flex m0 p0">
      <div class="clearfix primarycolor flex justify-start items-center pointer mb3 mr-auto" @click="gotominekunder()">
          <span class="mr1"><i class="el-icon-back"></i></span>
          <span class="h5 gibson line-height-1 m0 p0">Tilbage</span>
      </div>
      <div class="clearfix primarycolor flex justify-start items-center pointer mb3 ml-auto" @click="refreshpage()">
          <span class="mr1"><i class="el-icon-refresh-right"></i></span>
          <span class="h5 gibson line-height-1 m0 p0">Opdater</span>
      </div>
      </div>
      <!-- page header -->
      <div class="clearfix green flex justify-start items-center my3">
        <span class="mr1">
          <svg fill="currentColor" width="32" height="32" id="Capa_1" enable-background="new 0 0 512 512" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><g><circle cx="363" cy="457" r="10"/><path d="m384.803 429.456c4.906 2.535 10.94.609 13.473-4.299 11.595-22.466 17.724-47.762 17.724-73.157 0-77.401-55.074-141.871-127.878-156.758-.067-.014-.258-.05-.287-.055-7.182-1.454-14.492-2.405-21.835-2.863v-62.324c0-11.028 8.972-20 20-20 55.141 0 100-44.859 100-100 0-5.522-4.478-10-10-10h-30c-39.533 0-73.78 23.06-90 56.435-16.22-33.375-50.467-56.435-90-56.435h-30c-5.522 0-10 4.478-10 10 0 55.141 44.859 100 100 100 11.028 0 20 8.972 20 20v62.325c-85.072 5.296-150 76.085-150 159.675 0 88.225 71.775 160 160 160 26.438 0 52.658-6.616 75.826-19.134 4.858-2.625 6.669-8.692 4.044-13.552-2.626-4.859-8.692-6.668-13.552-4.044-18.472 9.981-39.172 15.654-60.216 16.579 2.78-1.459 4.772-4.17 5.249-7.382 2.363-15.918 9.08-21.771 19.247-30.63 6.79-5.917 14.485-12.622 22.055-23.288 8.312-11.703 11.517-25.941 9.024-40.096l-3.76-21.32c-.959-5.438-6.146-9.071-11.581-8.112l-18.807 3.311c-10.939 1.932-21.854-2.414-28.478-11.338-13.522-18.238-37.137-24.627-57.894-16.312-.061-.039-.12-.078-.18-.117-7.468-4.932-11.722-11.986-11.977-19.865-.167-5.156 1.373-10.263 4.268-14.706.999 1.813 2.641 3.548 5.447 4.49 3.504 1.177 7.329.313 9.984-2.148 4.286-3.976 3.258-8.837 2.484-11.915-.315-4.102-3.104-9.226.838-14.859 1.785-2.55 4.457-4.252 7.516-4.793l12.874-2.262c13.729-2.432 44.974-34.604 61.515-54.337 19.712 4.918 38.053 14.086 53.892 26.887-25.631 15.036-24.856 14.169-26.464 15.775-5.896 5.881-9.357 14.038-9.357 22.379v12.68c0 17.452 14.278 31.65 31.73 31.65 6.424 0 11.649 5.222 11.649 11.64 0 4.825 3.445 8.962 8.191 9.835l36.404 6.694c-.258 21.913-5.45 42.858-15.471 62.274-2.529 4.908-.604 10.94 4.303 13.472zm-158.803-339.456c-40.726 0-74.44-30.592-79.378-70h19.378c42.531 0 77.418 33.359 79.863 75.289-5.855-3.363-12.639-5.289-19.863-5.289zm120-70.01h19.378c-4.938 39.408-38.652 70.01-79.378 70.01-7.224 0-14.008 1.926-19.863 5.289 2.445-41.93 37.332-75.299 79.863-75.299zm-107.01 344.92c11.17 15.05 29.574 22.373 48.013 19.118l8.955-1.576 2.023 11.473c1.557 8.842-.444 17.736-5.637 25.048-6.193 8.728-12.646 14.35-18.885 19.786-6.788 5.915-13.72 11.954-18.851 21.131-6.82-9.013-11.384-11.004-14.334-13.104-.259-.503-.991-2.294-1.967-7.818-1.843-10.479-7.659-19.607-16.371-25.698l-6.772-4.744c9.339-13.981 8.919-32.295-1.134-45.844l-6.294-8.484c11.538-3.181 23.915.816 31.254 10.712zm-41.02 9.689c5.09 6.859 5.217 16.175.324 23.169l-5.24 7.471c-3.172 4.522-2.075 10.763 2.449 13.933l14.967 10.484c4.334 3.03 7.226 7.567 8.143 12.784 2.457 13.907 5.589 17.877 12.134 22.003 2.126 1.34 4.323 2.726 8.062 7.709l10.191 16.179c1.012 1.607 2.437 2.834 4.066 3.633-75.847-1.57-137.066-63.749-137.066-139.964 0-9.976 1.079-19.919 3.182-29.627 3.19 4.273 7.489 7.805 12.67 10.074l51.669 22.673zm26.643-123.731-12.543 2.204c-8.326 1.471-15.582 6.094-20.43 13.02-2.376 3.394-4.03 7.144-4.93 11.063-.952.428-1.875.97-2.749 1.634-12.344 9.353-19.428 23.767-18.948 38.559.092 2.82.461 5.592 1.092 8.289l-26.223-11.507c-5.416-2.372-8.26-8.347-6.472-13.605 1.957-5.767 2.263-11.918.949-17.756 24.981-43.753 71.214-70.769 121.641-70.769 3.591 0 7.185.14 10.767.415-17.538 19.56-36.555 36.308-42.154 38.453zm115.117 54.672c-6.424 0-11.73-5.227-11.73-11.65v-12.68c0-2.7 1.041-5.345 2.746-7.411l28.309-16.467c19.458 21.161 31.835 47.512 35.663 75.811l-24.51-4.507c-3.738-13.31-15.986-23.096-30.478-23.096z"/></g></svg>
        </span>
        <span class="h3 regular gibson lineheight-1 m0 p0">
          Klima
        </span>
      </div>
      <!-- checklist dropdown -->
      <div class="clearfix">
        <button @click="gotoSurvey()" class="col-12 p2 gibson white-collapse-button not-rounded flex justify-between items-center line-height-1 border muted-border shadow">
          <span class="h4 m0 p0 line-height-1">
            <span class="green mx1">
              <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><path d="M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z"/></svg>
            </span>
            <span>Checklist</span>
          </span>
          <span class="when-closed mx2">
            <i class="h4 el-icon-arrow-right"></i>
          </span>
        </button>
      </div>
      <div class="py2"></div>
      <!-- choose project select -->
      <div class="clearfix">
        <p class="h6 mediumgrey gibson line-height-1">Projekt</p>
        <!-- <select v-model="project" class="col-12 custom-select">
          <option :value="null" disabled>Vælg et projekt</option>
          <option v-for="(tilbud,index) in tilbudData" :key="index" :value="tilbud.id">REF{{tilbud.id}}-{{tilbud.pid}}</option>
        </select> -->
        <el-select v-model="project" placeholder="Vælg et projekt" class="col-12 p0 checklist" @change="projectChanged()">
          <el-option v-for="(tilbud,index) in tilbudData" :key="index" :label="tilbud.header_text" :value="tilbud.id">
            <div>
              <span style="font-size: 13px;">REF{{tilbud.id}}-{{tilbud.pid}}</span>
              <div>
                <span class="h6 bold">{{tilbud.header_text}}</span>
              </div>
              <div>
                <i class="el-icon-date"></i>
                <span style="font-size: 13px;">{{tilbud.createdtime.slice(0, -7)}}</span>
              </div>
            </div>
          </el-option>
        </el-select>
      </div>
      <div class="py2"></div>
      <div class="clearfix" v-if="insideLoading">
        <div class="col-12">
          <div class="loader"></div>
        </div>
      </div>
      <div v-else>
        <div v-if="klimaVisible">
          <!-- klima plan toggle -->
          <div class="highlights" v-if="klimaPlanVisible">
            <button class="col-12 p2 gibson white-collapse-button not-rounded flex justify-between items-center line-height-1">
              <span class="inline-block flex justify-start items-center">
                <span class="h2 line-height-1 primarycolor mt0 mr2 mb0">
                  <i class="el-icon-document"></i>
                </span>
                <span class="h4 gibson regular line-height-1 m0 p0">Klima Plan</span>
              </span>
              <div class="h4 primarycolor line-height-1 m0 p0"><!-- <i class="el-icon-right"></i> --></div>
              <!-- <span class="flex-none when-closed">
                <span class="relative" style="top:3px;">
                  <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-8 -5 24 24" width="18" height="18" preserveAspectRatio="xMinYMin" class="jam jam-chevron-right"><path d='M5.314 7.071l-4.95-4.95A1 1 0 0 1 1.778.707l5.657 5.657a1 1 0 0 1 0 1.414l-5.657 5.657a1 1 0 0 1-1.414-1.414l4.95-4.95z' /></svg>
                </span>
              </span>
              <span class="flex-none when-opened">
                <span class="relative" style="top:3px;">
                  <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -7.5 24 24" width="18" height="18" preserveAspectRatio="xMinYMin" class="jam jam-chevron-up"><path d='M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z' /></svg>
                </span>
              </span> -->
            </button>
            <b-collapse id="klimaPlan" visible>
              <div class="clearfix border-top mediumgrey-border p2">
                <div class="flex justify-between items-center mb1 pointer" v-if="mainKlimaVisible" @click="gotoEditKlima(klimaMainData.klimaId, 0)">
                  <div class="flex flex-column">
                    <div>
                      <span class="h6 darkblue semi-bold line-height-2">Rediger klimaplan</span>
                    </div>
                    <div class="h6 gibson line-height-1 m0 p0 mediumgrey flex justify-start items-center regular">
                      <span class="mr1">Id: {{klimaMainData.klimaId}}</span>
                      <span class="mr1">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="-2 -3 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-calendar-alt"><path d='M9 2V1a1 1 0 1 1 2 0v1h3V1a1 1 0 0 1 2 0v1h1a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h1V1a1 1 0 1 1 2 0v1h3zm0 2H6v1a1 1 0 1 1-2 0V4H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-1v1a1 1 0 0 1-2 0V4h-3v1a1 1 0 0 1-2 0V4zM3 8h2v2H3V8zm0 4h2v2H3v-2zm12 0h2v2h-2v-2zm0-4h2v2h-2V8zM7 8h2v2H7V8zm4 0h2v2h-2V8zm0 4h2v2h-2v-2zm-4 0h2v2H7v-2z'/></svg>
                      </span>
                      <span>{{klimaMainData.created_date}}</span>
                    </div>
                  </div>
                  <div class="h4 primarycolor line-height-1 m0 p0"><i class="el-icon-right"></i></div>
                </div>
                <div class="flex justify-between items-center pointer" v-if="draftKlimaVisible" @click="gotoEditKlima(klimaDraftData.klimaId, 1)">
                  <div class="flex flex-column">
                    <div>
                      <span class="h6 darkblue semi-bold line-height-2">Fortsæt kladden</span>
                    </div>
                    <div class="h6 gibson line-height-1 m0 p0 mediumgrey flex justify-start items-center regular">
                      <span class="mr1">Id: {{klimaDraftData.klimaId}}</span>
                      <span class="mr1">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="-2 -3 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-calendar-alt"><path d='M9 2V1a1 1 0 1 1 2 0v1h3V1a1 1 0 0 1 2 0v1h1a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h1V1a1 1 0 1 1 2 0v1h3zm0 2H6v1a1 1 0 1 1-2 0V4H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-1v1a1 1 0 0 1-2 0V4h-3v1a1 1 0 0 1-2 0V4zM3 8h2v2H3V8zm0 4h2v2H3v-2zm12 0h2v2h-2v-2zm0-4h2v2h-2V8zM7 8h2v2H7V8zm4 0h2v2h-2V8zm0 4h2v2h-2v-2zm-4 0h2v2H7v-2z'/></svg>
                      </span>
                      <span>{{klimaDraftData.created_date}}</span>
                    </div>
                  </div>
                  <div class="h4 primarycolor line-height-1 m0 p0"><i class="el-icon-right"></i></div>
                </div>
                <div v-if="!mainKlimaVisible && !draftKlimaVisible">
                  <!-- <span class="mediumgrey">Ingen data.</span> -->
                  <div class="flex flex-column justify-center items-center pointer " @click="addPlan()">
                    <i class="el-icon-circle-plus-outline green " style="font-size:4em;"></i>
                    <a class="semi-bold primarycolor pointer " >Opret Tilbud</a>
                  </div>
                </div>
              </div>
            </b-collapse>
          </div>
          <div class="py1"></div>
          <div class="highlights" v-if="klimaQualityAssuranceVisible">
            <button class="col-12 p2 gibson white-collapse-button flex justify-between not-rounded line-height-1" @click="gotoDocumentation(klimaMainData.klimaId)">
              <div>
                <span class="inline-block flex justify-start items-center">
                  <span class="h2 line-height-1 primarycolor mt0 mr2 mb0">
                    <i class="el-icon-files"></i>
                  </span>
                  <span class="h4 gibson regular line-height-1 m0 p0">Klima-kvalitetssikring</span>
                </span>
                <span class="block left-align mediumgrey">Id: {{klimaMainData.klimaId}}</span>
              </div>
              <div>
                <div class="h4 primarycolor line-height-1 m0 p0"><i class="el-icon-right"></i></div>
              </div>
            </button>
          </div>
        </div>
      </div>
      <!-- opret tilbud button -->
      <div class="clearfix my3 hide">
        <div class="flex flex-column justify-center items-center gibson">
          <div class="mx-auto center green-border" style="height:48px;width:48px;border-radius:50%;line-height:48px;border:2px solid;">
              <span class="darkblue semi-bold" style="font-size:24px;"><i class="el-icon-plus"></i></span>
            </div>
          <span class="center block h4 gibson darkblue line-height-1 mt2 mb0 p0">Opret tilbud</span>
        </div>
      </div>
      <div class="py4"></div> 
    </div>
  </div>
</template>
<style>
.el-select-dropdown__item {
  padding: 10px 20px;
  height: 80px;
  line-height: 20px;
}
.loader,
  .loader:before,
  .loader:after {
    border-radius: 50%;
  }
  .loader {
    color: #143130;
    font-size: 11px;
    text-indent: -99999em;
    margin: 55px auto;
    position: relative;
    width: 10em;
    height: 10em;
    box-shadow: inset 0 0 0 1em;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
  }
  .loader:before,
  .loader:after {
    position: absolute;
    content: '';
  }
  .loader:before {
    width: 5.2em;
    height: 10.2em;
    background: white;
    border-radius: 10.2em 0 0 10.2em;
    top: -0.1em;
    left: -0.1em;
    -webkit-transform-origin: 5.2em 5.1em;
    transform-origin: 5.2em 5.1em;
    -webkit-animation: load2 2s infinite ease 1.5s;
    animation: load2 2s infinite ease 1.5s;
  }
  .loader:after {
    width: 5.2em;
    height: 10.2em;
    background: white;
    border-radius: 0 10.2em 10.2em 0;
    top: -0.1em;
    left: 5.1em;
    -webkit-transform-origin: 0px 5.1em;
    transform-origin: 0px 5.1em;
    -webkit-animation: load2 2s infinite ease;
    animation: load2 2s infinite ease;
  }
  @-webkit-keyframes load2 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes load2 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
</style>


// WEBPACK FOOTER //
// checklist.vue?73dcacd1